import type { NavItem, NavSection, NavSectionId } from './navConfig';

export interface ActiveItem {
    section: NavSectionId;
    item: NavItem;
}

export const normalizePath = (pathname: string) => pathname.replace(/\/+$/, '').toLowerCase() || '/';

/** `/stories/stats` matches the links `stories/stats` and `stories`, never `s-tags`. */
export const pathMatches = (path: string, link: string) => {
    const target = `/${link.toLowerCase()}`;
    return path === target || path.startsWith(`${target}/`);
};

/**
 * The most specific visible item for the path (longest matching link), so `/stories/stats`
 * lights up "Stories Stats" only and an order's details page keeps its company highlighted.
 */
export const pickActiveItem = (sections: NavSection[], path: string): ActiveItem | null => {
    let best: ActiveItem | null = null;
    for (const section of sections) {
        for (const item of section.items) {
            if (!pathMatches(path, item.link)) continue;
            if (best === null || item.link.length > best.item.link.length) best = { section: section.id, item };
        }
    }
    return best;
};

/** Section to expand: the active item's, else a known menu-less route's, but only if that section is visible. */
export const sectionForPath = (
    sections: NavSection[],
    path: string,
    active: ActiveItem | null,
    hiddenRoutes: { prefix: string; section: NavSectionId }[]
): NavSectionId | null => {
    const candidate = active?.section ?? hiddenRoutes.find((hidden) => pathMatches(path, hidden.prefix))?.section ?? null;
    return candidate !== null && sections.some((section) => section.id === candidate) ? candidate : null;
};
